export const message = {
    "教学团队":"Teaching team",
    "自己":"Oneself",
    "暂无成员":"No member",
    "暂不支持给自己发送私信":"Sending private messages to yourself is temporarily not supported",
    "获取用户组失败组id为空":"Failed to get the user group. The group ID is empty",
    "查看聊天记录":"chat history",
    "历史":"history",
    "获取用户ID失败":"Failed to get user ID",
    "通讯录":"Mail list",
    "通知":"Notification",
    "查看旧版聊天记录":"View old chat history",
    "暂无消息":"No message",
}
